module.exports = {"650104001":"北京路街道","650104002":"二工街道","650104003":"三工街道","650104004":"石油新村街道","650104005":"迎宾路街道","650104006":"喀什东路街道","650104009":"八家户街道","650104010":"银川路街道","650104011":"南纬路街道","650104012":"杭州路街道","650104013":"鲤鱼山街道","650104014":"百园路街道","650104015":"正扬路街道","650104016":"机场街道","650104017":"友谊路街道","650104018":"高新街街道","650104019":"长春中路街道","650104100":"安宁渠镇","650104200":"二工乡","650104201":"地窝堡乡","650104202":"青格达湖乡","650104203":"六十户乡","650104402":"十二师养禽场街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650104.json
// module id = 3191
// module chunks = 0